"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Breakpoints = {
    bp375: 375,
    bp425: 425,
    bp480: 480,
    bp640: 640,
    bp768: 768,
    bp840: 840,
    bp1024: 1024,
    bp1168: 1168,
    bp1280: 1280,
    bp1920: 1920,
};
exports.default = Breakpoints;
//# sourceMappingURL=Breakpoints.js.map